import { useState, useEffect } from 'react';

import { DomainConfig, getDomainConfig, DomainType } from '@/config/domainConfig';

/**
 * Hook to get current domain configuration
 * Automatically detects domain on client-side
 */
export const useDomainConfig = (): DomainConfig => {
  const [config, setConfig] = useState<DomainConfig>(() => {
    // Initialize with server-side safe default
    if (typeof window === 'undefined') {
      return getDomainConfig('fixd.ai');
    }
    return getDomainConfig(window.location.hostname);
  });

  useEffect(() => {
    // Update config when hostname changes (shouldn't happen often but good to handle)
    const currentConfig = getDomainConfig(window.location.hostname);
    setConfig(currentConfig);
  }, []);

  return config;
};

/**
 * Hook to get current domain type
 */
export const useDomainType = (): DomainType => {
  const config = useDomainConfig();
  return config.type;
};

/**
 * Hook to check if current domain is Fixd.ai
 */
export const useIsFixdDomain = (): boolean => {
  const config = useDomainConfig();
  return config.type === 'fixdai';
};

/**
 * Hook to check if current domain is Terr.ai
 */
export const useIsTerraiDomain = (): boolean => {
  const config = useDomainConfig();
  return config.type === 'terrai';
};
